import { useQuery } from '@tanstack/react-query'
import { getCourseStats } from '@/api/stats'

const useCourseStats = () => {
  return useQuery({
    queryKey: ['course-stats'],
    queryFn: ({ signal }) => getCourseStats(signal),
    retry: 1,
  })
}

export default useCourseStats
